/**
 * Consistent loading placeholder for data pages (MYSKUX-020). Carries a
 * role="status" live region so screen readers announce loading, replacing the
 * page-by-page hand-rolled skeleton markup.
 */
export function PageSkeleton({ rows = 4, maxWidth, ariaLabel = 'Loading' }: { rows?: number; maxWidth?: string; ariaLabel?: string }) {
  return (
    <div role="status" aria-label={ariaLabel} style={maxWidth ? { maxWidth } : undefined}>
      <span className="sr-only">{ariaLabel}…</span>
      <div className="skeleton-heading" />
      <div className="card card-body-skeleton">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="skeleton-row" />
        ))}
      </div>
    </div>
  );
}
